import { Component, forwardRef, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'cwo-custom-checkbox',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-checkbox.component.html',
  styleUrl: './custom-checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomCheckboxComponent),
      multi: true,
    },
  ],
})
export class CustomCheckboxComponent implements ControlValueAccessor {
  checked = false;
  loading = input(false);
  ariaLabel = input<string | undefined>(undefined);
  name = input<string | undefined>(undefined);
  useStopPropagation = input<boolean>(true);
  labelName = input<string>('');
  labelClass = input<string>('');
  borderHighlight = input<boolean>(false);
  inputTabIndex = input<number>(0);
  
  private onTouch = () => {return undefined};
  private onChange = (val: any) => {return val};


  toggleCheckbox(event: Event): void {
    if(this.useStopPropagation()) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.onTouch();
    
    if (this.loading()) {
      return;
    }
    
    this.writeValue(!this.checked);
    this.onChange(this.checked);
  }

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}